module.exports = __webpack_public_path__ + "img/sj_gangtieshengchan.61050311.jpg";